export class TimeLoggerDTOModel {
    public dateLogged: string;
    public timeLogged: number;
    public type: number;
    public lat: number;
    public lng: number;

    [x: string]: any;
}
